export enum NdaTermStep {
    InitialSelection,
    TermsNegotiation,
    TermsAgreed
}